import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Link2, Plus, Trash2, Loader2 } from "lucide-react";

export default function GruposPanel({ grupos, nome, onNomeChange, link, onLinkChange, adding, onAdd, onDelete }) {
  return (
    <div className="glass-card overflow-hidden" data-testid="admin-grupos-section">
      <div className="section-accent p-5 sm:p-6">
        <h2 className="font-heading text-lg font-semibold text-slate-100">Grupos Controlados</h2>
        <p className="text-xs text-slate-500 mt-1">Gerenciamento exclusivo do administrador: cadastre links de convite e os chips conectados entram automaticamente (chips reais entram de verdade via Evolution).</p>
      </div>
      <div className="p-5 sm:p-6 space-y-4">
        <div className="flex flex-col sm:flex-row gap-3">
          <Input value={nome} onChange={(e) => onNomeChange(e.target.value)} placeholder="Nome do grupo (ex: Networking Afiliados)"
            data-testid="admin-grupo-nome-input"
            className="bg-slate-800/60 border-slate-700 text-slate-100 placeholder:text-slate-500 focus-visible:ring-2 focus-visible:ring-emerald-500 sm:w-72" />
          <Input value={link} onChange={(e) => onLinkChange(e.target.value)} placeholder="https://chat.whatsapp.com/..."
            data-testid="admin-grupo-link-input"
            className="bg-slate-800/60 border-slate-700 text-slate-100 placeholder:text-slate-500 flex-1 font-mono text-sm focus-visible:ring-2 focus-visible:ring-emerald-500" />
          <Button onClick={onAdd} disabled={adding} data-testid="admin-grupo-add-button"
            className="bg-emerald-500 hover:bg-emerald-600 text-emerald-950 font-semibold">
            {adding ? <Loader2 className="w-4 h-4 animate-spin" /> : (<><Plus className="w-4 h-4 mr-2" /> Cadastrar grupo</>)}
          </Button>
        </div>
        <div className="divide-y divide-white/[0.04] border border-white/[0.06] rounded-lg overflow-hidden">
          {grupos.length === 0 ? (
            <p className="p-6 text-center text-sm text-slate-500" data-testid="admin-grupos-empty">Nenhum grupo cadastrado ainda.</p>
          ) : (
            grupos.map((g) => (
              <div key={g.id} className="p-4 flex items-center gap-3 hover:bg-white/[0.02] transition-colors" data-testid={`admin-grupo-row-${g.id}`}>
                <div className="w-9 h-9 rounded-lg bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center shrink-0">
                  <Link2 className="w-4 h-4 text-emerald-400" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-slate-200 truncate">{g.nome}</p>
                  <p className="text-xs text-slate-500 font-mono truncate">{g.link}</p>
                </div>
                <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-slate-800 text-slate-300 border border-slate-700 shrink-0">
                  {g.membros} chip(s)
                </span>
                <button onClick={() => onDelete(g)} data-testid={`admin-grupo-delete-${g.id}`}
                  className="p-2 text-slate-500 hover:text-red-300 hover:bg-red-500/10 rounded-lg transition-colors shrink-0">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
